
import { Component, Prop, Vue } from 'vue-property-decorator';
import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import { schedule9DataInfoType } from '@/types/Application/ReplyFamilyLawMatter/Pdf';
import { disagreeSpouseSupportDataInfoType, rflmCalculatingSpouseSupportDataInfoType } from '@/types/Application/ReplyFamilyLawMatter/SpousalSupport';
import { howToPaySpousalSupportInfoType } from '@/types/Application/FamilyLawMatter/SpousalSupport';

@Component({
    components:{
        UnderlineForm,
        CheckBox
    }
})

export default class Schedule9 extends Vue {

    @Prop({required:true})
    result!: any;
  
    dataReady = false;
    spsSupInfo = {} as schedule9DataInfoType;    
   
    mounted(){
        this.dataReady = false;        
        this.extractInfo();       
        this.dataReady = true;        
    } 

    public extractInfo(){
        console.log(this.result)
        this.spsSupInfo = this.getNewSpousalSupportInfo();
    }

    public getNewSpousalSupportInfo(){

        let newSpousalSupportInfo = {} as schedule9DataInfoType;

        if (this.result.relationshipToOtherPartySurvey){
            newSpousalSupportInfo.spouse = this.result.relationshipToOtherPartySurvey.spouse == 'y';
        } else {
            newSpousalSupportInfo.spouse = false;
        }

        newSpousalSupportInfo.disagreeDetails = {                
            noEntitlement: false,
            noEntitlementDesc: '',
            incorrectIncomeClaim: false,
            incorrectEmploymentClaim: false,
            incorrectEmploymentClaimDesc: '',
            incorrectOpFinancialClaim: false,
            incorrectOpFinancialClaimDesc: '',
            incorrectOpEmploymentClaim: false,
            incorrectOpEmploymentClaimDesc: '',
            incorrectOpExpenseClaim: false,
            incorrectOpExpenseClaimDesc: '',
            other: false,
            otherDesc: ''
        }

        if (this.result.disagreeSpouseSupportSurvey){
            const disagreeInfo: disagreeSpouseSupportDataInfoType = this.result.disagreeSpouseSupportSurvey;
            if (disagreeInfo.noEntitlement == "true"){
                newSpousalSupportInfo.disagreeDetails.noEntitlement = true;
                newSpousalSupportInfo.disagreeDetails.noEntitlementDesc = disagreeInfo.noEntitlementDescription;
            } else {
                newSpousalSupportInfo.disagreeDetails.noEntitlement = false;
                newSpousalSupportInfo.disagreeDetails.noEntitlementDesc = "";
            }

            newSpousalSupportInfo.disagreeDetails.incorrectIncomeClaim = disagreeInfo.incorrectIncomeAndAbilityToWork == "true";
            
            if (disagreeInfo.incorrectEmployment == "true"){
                newSpousalSupportInfo.disagreeDetails.incorrectEmploymentClaim = true;
                newSpousalSupportInfo.disagreeDetails.incorrectEmploymentClaimDesc = disagreeInfo.incorrectEmploymentDescription;
            } else {
                newSpousalSupportInfo.disagreeDetails.incorrectEmploymentClaim = false;
                newSpousalSupportInfo.disagreeDetails.incorrectEmploymentClaimDesc = "";
            }

            if (disagreeInfo.opIncorrectFinances == "true"){
                newSpousalSupportInfo.disagreeDetails.incorrectOpFinancialClaim = true;
                newSpousalSupportInfo.disagreeDetails.incorrectOpFinancialClaimDesc = disagreeInfo.opIncorrectFinancesDescription;

            } else {
                newSpousalSupportInfo.disagreeDetails.incorrectOpFinancialClaim = false;
                newSpousalSupportInfo.disagreeDetails.incorrectOpFinancialClaimDesc = "";
            }

            if (disagreeInfo.opIncorrectEmployment == "true"){
                newSpousalSupportInfo.disagreeDetails.incorrectOpEmploymentClaim = true;
                newSpousalSupportInfo.disagreeDetails.incorrectOpEmploymentClaimDesc = disagreeInfo.opIncorrectEmploymentDescription;
            } else {
                newSpousalSupportInfo.disagreeDetails.incorrectOpEmploymentClaim = false;
                newSpousalSupportInfo.disagreeDetails.incorrectOpEmploymentClaimDesc = "";
            }

            if (disagreeInfo.opIncorrectExpenses == "true"){
                newSpousalSupportInfo.disagreeDetails.incorrectOpExpenseClaim = true;
                newSpousalSupportInfo.disagreeDetails.incorrectOpExpenseClaimDesc = disagreeInfo.opIncorrectExpensesDescription;
            } else {
                newSpousalSupportInfo.disagreeDetails.incorrectOpExpenseClaim = false;
                newSpousalSupportInfo.disagreeDetails.incorrectOpExpenseClaimDesc = "";
            }

            if (disagreeInfo.disagreeOtherReason == 'y'){
                newSpousalSupportInfo.disagreeDetails.other = true;
                newSpousalSupportInfo.disagreeDetails.otherDesc = disagreeInfo.otherReasonDescription;
            } else {
                newSpousalSupportInfo.disagreeDetails.other = false;
                newSpousalSupportInfo.disagreeDetails.otherDesc = "";
            }
            
        }

        newSpousalSupportInfo.payDetails = {
            monthly: false,
            start: '',
            end: '',
            rate: '',
            lumpSum: false,
            lumpSumAmount: '',
            other: false,
            otherComm: ''
        }

        if (this.result.rflmSpouseSupportOrderSurvey?.howToPaySpousalSupport){
            const supportOrder: howToPaySpousalSupportInfoType = this.result.rflmSpouseSupportOrderSurvey.howToPaySpousalSupport;
            newSpousalSupportInfo.payDetails = {
                monthly: supportOrder.selected == 'monthly',
                start: (supportOrder.selected == 'monthly'
                        && supportOrder.monthlyStartDate)?Vue.filter('beautify-date')(supportOrder.monthlyStartDate):'',
                end: (supportOrder.selected == 'monthly'
                        && supportOrder.monthlyEndDate)?Vue.filter('beautify-date')(supportOrder.monthlyEndDate):'',
                rate: (supportOrder.selected == 'monthly'
                        && supportOrder.monthlyAmount)?supportOrder.monthlyAmount:'',
                lumpSum: supportOrder.selected == 'Lump Sum',
                lumpSumAmount: (supportOrder.selected == 'Lump Sum'
                        && supportOrder.lumpsumAmount)? supportOrder.lumpsumAmount:'',
                other: supportOrder.selected == 'other',
                otherComm: (supportOrder.selected == 'other' 
                        && supportOrder.otherComment)? supportOrder.otherComment:''
            }
        }

        newSpousalSupportInfo.calc = {                
            attaching: false,
            reason: ''
        }

        if (this.result.rflmCalculatingSpouseSupportSurvey){
            const calculationInfo: rflmCalculatingSpouseSupportDataInfoType = this.result.rflmCalculatingSpouseSupportSurvey;
                    
            newSpousalSupportInfo.calc = {                
                attaching: calculationInfo.attachingCalculations == 'y',
                reason: calculationInfo.attachingCalculations == 'n'?calculationInfo.notAttachingCalculationsReason:''
            } 
        
        } 

        if (this.result.flmAdditionalDocumentsSurvey){
            newSpousalSupportInfo.filingForm4 = this.result.flmAdditionalDocumentsSurvey.isFilingAdditionalDocs == 'y';
        } else {
            newSpousalSupportInfo.filingForm4 = false;
        }        

        return newSpousalSupportInfo;
    }
}
